import ReactDOM from "react-dom";
import App from "./App";
import * as auth from "./auth/auth";
import { bootstrapAuth } from "./auth/bootstrap";
import { LoginContainer } from "./auth/login";
import "./index.css";
import { AUTH_CONFIGS } from "./auth/authConfigs";
import { clearCognitoSession } from "./auth/localStorage";
import { determineMaximumScaleViewport } from "./util/dom";

determineMaximumScaleViewport();

const showError = (error: any) => {
    document.write(
        "An unexpected error occurred. Please try again. If you are using an old browser (like IE11) please try again using something more modern. If the problem persist please contact support@dintero.com ",
    );
    // rethrow error so sentry can log it
    throw error;
};

const newCognitoLogin = () => {
    // We don't have a valid user session
    if (AUTH_CONFIGS.aws_cognito_sso_enterprise_vy) {
        // Redirect to cognito if external auth from vy
        auth.loginViaRedirect();
    } else {
        // Render login container
        ReactDOM.render(<LoginContainer />, document.getElementById("root"));
    }
};

const startApp = () => {
    try {
        bootstrapAuth(window.location.pathname)
            .then((result) => {
                if (result === "app") {
                    // Start react application
                    ReactDOM.render(<App />, document.getElementById("root"));
                } else {
                    newCognitoLogin();
                }
            })
            .catch((error) => {
                console.log("Authenticate from session failed", error);
                clearCognitoSession();
                return newCognitoLogin();
            });
    } catch (error) {
        showError(error);
    }
};

// Force a reload when page is loaded from bfcache
window.onpageshow = (event: PageTransitionEvent) => {
    if (event.persisted) {
        window.location.reload();
        return;
    } else {
        startApp();
    }
};
